<template>
  <div class="modal-level2-container">
    <Email v-show="$store.state.modalStore.showNewVendorEmail" />
    <div class="modal-level2-dialog">
      <div class="modal-level2-content">
        <div class="modal-level2-body">
          <div class="modal-button-close">
            <i class="far fa-times-circle" @click="closeModal()"></i>
          </div>
          <div class="lv3-full-container">
            <div class="lv3-full-tittle">TIKET VENDOR BARU</div>
            <div class="lv3-full-wrapper">
              <div class="lv3-half-container">
                <div class="half-input-wrapper">
                  <div class="hiw-label">Request ID</div>
                  <input type="text" class="hiw-text" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Deskripsi <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Nama Pengadaan <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Kategori <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Nama Vendor <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    PIC Vendor <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Email Vendor <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Priority</div>
                  <input type="text" class="hiw-text" />
                </div>
              </div>
              <div class="lv3-half-container">
                <div class="half-input-wrapper">
                  <div class="hiw-label">Due By</div>
                  <div class="hiw-multiple">
                    <input class="hiw-2-row" type="date" />
                    <input class="hiw-2-row" type="date" />
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Bidang Usaha</div>
                  <div class="hiw-multiple">
                    <label class="hiw-2-row"
                      ><input
                        type="radio"
                        value="badan"
                        v-model="chooseBu"
                        style="margin-right: 10px"
                      />Badan Usaha</label
                    >
                    <label class="hiw-2-row"
                      ><input
                        type="radio"
                        value="perorangan"
                        v-model="chooseBu"
                        style="margin-right: 10px"
                      />Perorangan</label
                    >
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Registrasi ke Sistem <span class="text-ast">*</span>
                  </div>
                  <div class="hiw-multiple">
                    <label class="hiw-3-row"
                      ><input
                        type="checkbox"
                        v-model="chooseServer"
                        value="gems"
                        style="margin-right: 10px"
                      />SAP GEMS</label
                    >
                    <label class="hiw-3-row"
                      ><input
                        type="checkbox"
                        v-model="chooseServer"
                        value="bce"
                        style="margin-right: 10px"
                      />SAP BCE</label
                    >
                    <label class="hiw-3-row"
                      ><input
                        type="checkbox"
                        v-model="chooseServer"
                        value="bkes"
                        style="margin-right: 10px"
                      />SAP BKES</label
                    >
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Tipe Pendaftaran Vendor</div>
                  <div class="hiw-multiple">
                    <label class="hiw-4-row"
                      ><input
                        type="radio"
                        value="std"
                        v-model="chooseTypeRegister"
                        style="margin-right: 10px"
                      />Standart</label
                    >
                    <label class="hiw-4-row"
                      ><input
                        type="radio"
                        value="pa"
                        v-model="chooseTypeRegister"
                        style="margin-right: 10px"
                      />Internasional</label
                    >
                    <label class="hiw-4-row"
                      ><input
                        type="radio"
                        value="vk"
                        v-model="chooseTypeRegister"
                        style="margin-right: 10px"
                      />Khusus</label
                    >
                    <label class="hiw-4-row"
                      ><input
                        type="radio"
                        value="im"
                        v-model="chooseTypeRegister"
                        style="margin-right: 10px"
                      />Internal Memo <i class="fas fa-upload"></i>
                    </label>
                    <input
                      type="file"
                      class="hiw-text"
                      v-show="chooseTypeRegister == 'im'"
                    />
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Assesment</div>
                  <div class="hiw-multiple">
                    <label class="hiw-2-row"
                      ><input
                        type="checkbox"
                        v-model="chooseAssesment"
                        value="k3l"
                        style="margin-right: 10px"
                      />K3L</label
                    >
                    <label class="hiw-2-row"
                      ><input
                        type="checkbox"
                        v-model="chooseAssesment"
                        value="kplh"
                        style="margin-right: 10px"
                      />KPLH</label
                    >
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Document Legalitas</div>
                  <input type="file" class="hiw-text" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Note</div>
                  <textarea class="hiw-area" />
                </div>
              </div>
            </div>
            <div class="lv3-full-btn-wrapper">
              <div class="lv3-btn-submit" @click="showModal()">SUBMIT</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Email: () => import('@/components/modal/newVendorEmail.vue'),
  },
  data() {
    return {
      chooseBu: '',
      chooseTypeRegister: '',
      chooseAssesment: [],
      chooseServer: [],
    }
  },
  methods: {
    showModal() {
      this.$store.commit('modalStore/SHOW_NEW_VENDOR_EMAIL')
    },
    closeModal() {
      this.$store.commit('modalStore/CLOSE_NEW_VENDOR')
    },
  },
}
</script>
